import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Ao3SeoManager from "./components/feature/Ao3SeoManager";
import Ao3Schema from "./components/feature/Ao3Schema";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <Ao3SeoManager />
        <Ao3Schema />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
